// extracted by mini-css-extract-plugin
module.exports =  {"container":"Ic7bzny","icon":"raHo6Y_"};